/**
 * `?debug=1` — LE MÊME MOT, PARTOUT.
 *
 * Ce prédicat existait déjà, écrit trois fois à l'identique (ARExperience,
 * ReveilExperience, et maintenant le mur de la Veillée). Le recopier une
 * quatrième fois, c'était accepter qu'un jour l'un des trois lise `?debug`
 * ou `?diag=1` et qu'un opérateur, sur place, tape la mauvaise chose devant
 * un écran qui ne lui répond pas. Une grammaire de diagnostic qui varie
 * d'un écran à l'autre n'est pas une grammaire.
 *
 * Le contrat, inchangé depuis l'AR :
 *   · un SEUL paramètre, `?debug=1`, exactement ;
 *   · rien de visible pour l'invité — c'est un outil d'opérateur ;
 *   · pas d'i18n (outil technique, français de la maison) ;
 *   · ABSENT ⇒ AUCUN effet : pas d'écouteur posé, pas de nœud monté, pas un
 *     octet de travail en plus. C'est la condition pour qu'on ose l'appeler
 *     depuis des chemins chauds.
 */
export function isDebugMode() {
    try {
        return new URLSearchParams(window.location.search).get('debug') === '1';
    } catch {
        return false;
    }
}

export default isDebugMode;
